import React, { Component, Fragment } from "react";
import {
  AppBar,
  Button,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

export class DomainVerification extends Component {
  constructor() {
    super();
    this.state = {
      disabled: false,
      errorMessage: "",
      successMessage: "",
      tableLoader: false,
      dnsList: "",
    };
  }

  continue = (e) => {
    e.preventDefault();
    //PROCESS FORM//
    this.props.nextStep();
  };
  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  submitForm = async () => {
    // Block duplicate submissions while the request is in flight.
    if (this.state.tableLoader === true) {
      return;
    }
    this.setState({
      tableLoader: true,
      disabled: true,
    });
    try {
      await this.props.submitDomain();
    } finally {
      // Reset on both success and failure.
      this.setState({
        tableLoader: false,
        disabled: false,
      });
    }
  };

  verificationResult = () => {
    // console.log("dnsList.DNSData.dnsRecords", this.props);
    /*if (dnsList.ErrorMessage) {
      return (
        <div className="callout callout-danger">
          <h4>Error verifying the domain</h4>
          {dnsList.ErrorMessage.msg}
        </div>
      );
    } else if (dnsList.DNSData.dnsRecords) {
      return (
        <>
          {dnsList.DNSData.dnsRecords.map((dns) => (
            <p>{dns.type}</p>
          ))}
        </>
      );
    }*/
  };

  render() {
    const {
      values: { values, domain_title, domain_name, dnsList, a_ip },
    } = this.props;

    // console.log("Verification dnsList: ", dnsList);

    return (
      <>
        <div className="col-lg-12">
          <div className="nk-block">
            <div className="card card-bordered card-stretch">
              <div className="card-inner-group" style={{ padding: "40px" }}>
                <h5>Connect your domain</h5>

                {/* Editable on every step: changes go straight to the wizard
                    parent's state, and a changed domain name clears the DNS
                    result below so it must be verified again. */}
                <div className="form-group" style={{ marginTop: "20px" }}>
                  <TextField
                    required
                    id="domain_title"
                    name="domain_title"
                    type="text"
                    label="Domain Title"
                    defaultValue={domain_title}
                    inputProps={{ maxLength: 100 }}
                    onChange={this.props.handleChange("domain_title")}
                    helperText="Enter the domain title. e.g ABC Company"
                    variant="outlined"
                    fullWidth
                    disabled={this.state.disabled}
                  />
                </div>
                <div className="form-group">
                  <TextField
                    required
                    id="domain_name"
                    name="domain_name"
                    type="text"
                    label="Domain"
                    defaultValue={domain_name}
                    inputProps={{ maxLength: 100 }}
                    onChange={this.props.handleChange("domain_name")}
                    helperText="Enter the domain you want to connect. e.g. example.com (without http:// or https://). Changing it requires verifying the connection again."
                    variant="outlined"
                    fullWidth
                    disabled={this.state.disabled}
                  />
                </div>

                {this.props.values.errorMessage ? (
                  <div
                    className="alert alert-pro alert-danger"
                    style={{ marginTop: "30px" }}
                  >
                    <div className="alert-text">
                      <h6>Error</h6>
                      <p>{this.props.values.errorMessage}</p>
                    </div>
                  </div>
                ) : null}
                {this.props.values.warningMessage ? (
                  <div
                    className="alert alert-pro alert-warning"
                    style={{ marginTop: "30px" }}
                  >
                    <div className="alert-text">
                      <h6>Warning</h6>
                      <p>{this.props.values.warningMessage}</p>
                    </div>
                  </div>
                ) : null}
                {this.props.values.successMessage ? (
                  <div
                    className="alert alert-pro alert-success"
                    style={{ marginTop: "30px" }}
                  >
                    <div className="alert-text">
                      <h6>Success</h6>
                      <p>{this.props.values.successMessage}</p>
                    </div>
                  </div>
                ) : null}
                {dnsList.DNSData ? (
                  <>
                    {dnsList.DNSData.dnsRecords.map((dns, index) => (
                      <>
                        {dns.type == 1 ? (
                          <>
                            {dns.address ==
                            process.env.REACT_APP_AGENT_PORTAL_DNS ? (
                              <>
                                <div className="alert alert-pro alert-success">
                                  <h4>Domain Verified</h4>
                                  Your domain is verified. Now complete the
                                  verification process by clicking the Complete
                                  Domain Registration button.
                                  <br />
                                  <br />
                                  {/*<button
                                    className="btn btn-lg btn-outline-dark"
                                    onClick={this.submitForm}
                                    style={{ marginRight: "10px" }}
                                  >
                                    Add Domain
                            </button>*/}
                                </div>
                                <p>
                                  <strong style={{ fontWeight: "bold" }}>
                                    A RECORD
                                  </strong>{" "}
                                  (@)
                                  <br />
                                  <br />
                                  Current IP address: {dns.address} <br />
                                  Required IP address:{" "}
                                  {process.env.REACT_APP_AGENT_PORTAL_DNS}
                                </p>
                              </>
                            ) : (
                              <>
                                <p>
                                  <strong style={{ fontWeight: "bold" }}>
                                    A RECORD entered incorrectly
                                  </strong>{" "}
                                  <br />
                                  Check that you've entered the required values,
                                  and verify your connection again.
                                </p>
                                <p>
                                  <strong style={{ fontWeight: "bold" }}>
                                    A RECORD
                                  </strong>{" "}
                                  (@)
                                  <br />
                                  Current IP address:{" "}
                                  <span style={{ color: "red" }}>
                                    {dns.address}
                                  </span>{" "}
                                  <br />
                                  Required IP address:{" "}
                                  {process.env.REACT_APP_AGENT_PORTAL_DNS}
                                </p>
                                <div className="callout callout-danger">
                                  <h4>Connection Incomplete</h4>
                                  Some providers take few minutes to update
                                  their settings. If you want to verify again,
                                  return one step back and click "Verify
                                  Connection" button.
                                  <br />
                                  <br />
                                  {/*<button
                                    className="btn btn-lg btn-outline-dark"
                                    onClick={this.submitForm}
                                    style={{ marginRight: "10px" }}
                                  >
                                    Add Domain
                            </button>*/}
                                </div>
                              </>
                            )}
                          </>
                        ) : null}
                      </>
                    ))}
                  </>
                ) : null}

                {/* Shown only when there is no DNS result AND no other message
                    already explaining why (a failed lookup sets warningMessage)
                    - i.e. the domain was edited here or verification was
                    skipped. */}
                {!dnsList.DNSData &&
                !this.props.values.warningMessage &&
                !this.props.values.errorMessage ? (
                  <div className="alert alert-pro alert-warning">
                    <div className="alert-text">
                      <h6>Verification pending</h6>
                      <p>
                        This domain has no verification result yet. Go one step
                        back and click "Verify Connection", or add the domain
                        now and verify it later from the listing (a 24-hour
                        verification window starts when it is added).
                      </p>
                    </div>
                  </div>
                ) : null}

                <hr />
                <div className="form-group text-right">
                  <button
                    className="btn btn-lg btn-default  btn-outline-dark"
                    onClick={this.back}
                    disabled={this.state.disabled}
                    style={{ marginRight: "10px" }}
                  >
                    Back
                  </button>
                  {this.state.tableLoader === true ? (
                    <button className="btn btn-lg btn-primary" disabled>
                      <em className="icon ni ni-swap"></em> Add Domain
                      <div
                        className="spinner-grow spinner-grow-sm"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </button>
                  ) : (
                    <button
                      className="btn btn-lg btn-primary"
                      onClick={this.submitForm}
                    >
                     Add Domain
                      <em className="icon ni ni-done"></em>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default DomainVerification;
